<template>
  <div>
    <v-card>
      <v-toolbar flat v-if="meter !== null" height="90" outlined>
        <v-toolbar-title>
          <p
            class="subtitle-1 text-uppercase font-weight-bold ma-0 primary--text"
            style="white-space: normal"
          >
            {{ meter.circuit }}
            <v-menu v-model="signal" :close-on-content-click="false" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon x-small v-bind="attrs" v-on="on">
                  <v-icon
                    x-small
                    :color="getColor(meter.circuit)"
                    @mouseover="batsignal(true)"
                    @mouseout="batsignal(false)"
                  >
                    mdi-checkbox-blank-circle
                  </v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-text class="pa-0 disp">
                  <v-list>
                    <v-list-item dense>
                      <v-list-item-content
                        class="font-weight-bold primary--text"
                      >
                        Status:
                      </v-list-item-content>
                      <v-list-item-action class="text-caption font-weight-bold">
                        {{ status }}
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-menu>
          </p>
          <p
            class="caption ma-0"
            v-if="reading.timestamp"
            style="font-size: 10px !important"
          >
            Last update:
            {{ new Date(reading.timestamp).getMonth() + 1 }}/{{
              new Date(reading.timestamp).getDate()
            }}/{{ new Date(reading.timestamp).getFullYear() }}
            {{ hourConverted }}
          </p>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-menu v-model="menu" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-information-outline </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-text class="pa-0">
              <v-list>
                <v-list-item dense>
                  <v-list-item-content class="font-weight-bold primary--text">
                    Version:
                  </v-list-item-content>
                  <v-list-item-action class="text-caption font-weight-bold">
                    {{ meter.currentVersion }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item dense>
                  <v-list-item-content class="font-weight-bold primary--text">
                    Id sim:
                  </v-list-item-content>
                  <v-list-item-action class="text-caption font-weight-bold">
                    {{ meter.sim_id }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item dense>
                  <v-list-item-content class="font-weight-bold primary--text">
                    Location:
                  </v-list-item-content>
                  <v-list-item-action class="text-caption font-weight-bold">
                    {{ meter.location.latitude }},
                    {{ meter.location.longitude }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item dense>
                  <v-list-item-content class="font-weight-bold primary--text">
                    ADE:
                  </v-list-item-content>
                  <v-list-item-action class="text-caption font-weight-bold">
                    {{ infohw.ADE ? infohw.ADE : "N/A" }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item dense>
                  <v-list-item-content class="font-weight-bold primary--text">
                    CT max current:
                  </v-list-item-content>
                  <v-list-item-action class="text-caption font-weight-bold">
                    {{ infohw.CT_max_current ? infohw.CT_max_current : "N/A" }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item dense>
                  <v-list-item-content class="font-weight-bold primary--text">
                    Modem:
                  </v-list-item-content>
                  <v-list-item-action class="text-caption font-weight-bold">
                    {{ infohw.modem ? infohw.modem : "N/A" }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item dense>
                  <v-list-item-content class="font-weight-bold primary--text">
                    Radio:
                  </v-list-item-content>
                  <v-list-item-action class="text-caption font-weight-bold">
                    {{ infohw.radio_info ? infohw.radio_info : "N/A" }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action class="text-caption font-weight-bold">
                    <v-btn color="accent" small @click="openTable = true"
                      >Reports
                      <v-icon small class="ml-2">mdi-clipboard-text</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-dialog v-model="openTable">
              <template>
                <v-card height="660">
                  <tableReport :meter="meter" @close="closeAll()" />
                </v-card>
              </template>
            </v-dialog>
          </v-card>
        </v-menu>
      </v-toolbar>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import tableReport from "../Circuit/table.vue";
import { Meter } from "../../api";
export default {
  name: "info",
  props: ["meter", "reading"],
  components: { tableReport },
  computed: {
    ...mapState({
      arrayON: (state) => state.meters.arrayON,
      arrayUP: (state) => state.meters.arrayUP,
      arrayDOWN: (state) => state.meters.arrayDOWN,
      arrayOFF: (state) => state.meters.arrayOFF,
      arrayOUT: (state) => state.meters.arrayOUT,
    }),
  },
  data() {
    return {
      menu: false,
      status: "",
      signal: false,
      hourConverted: null,
      openTable: false,
      fn: "",
      infohw: {
        ADE: "N/A",
        CT_max_current: "N/A",
        modem: "N/A",
        radio_info: false,
      },
    };
  },
  methods: {
    getColor(meter) {
      let status = this.arrayUP.find((m) => m.circuit === meter);
      if (status != undefined) {
        this.status = "Overconsumption";
        return "orange darken-3";
      }
      status = this.arrayDOWN.find((m) => m.circuit === meter);
      if (status != undefined) {
        this.status = "Underconsumption";
        return "yellow darken-2";
      }
      status = this.arrayON.find((m) => m.circuit === meter);
      if (status != undefined) {
        this.status = "On";
        return "accent";
      }
      status = this.arrayOFF.find((m) => m.circuit === meter);
      if (status != undefined) {
        this.status = "Off";
        return "grey darken-3";
      }
      status = this.arrayOUT.find((m) => m.circuit === meter);
      if (status != undefined) {
        this.status = "Offline";
        return "red";
      }
    },
    batsignal(s) {
      if (s) this.signal = true;
      else this.signal = false;
    },
    setTime() {
      let hour = moment(this.reading.timestamp).format("LTS");
      this.hourConverted = moment(hour, "h:mm:ss A").format("HH:mm:ss");
    },
    closeAll() {
      this.openTable = false;
      this.menu = false;
    },
    async getInfoHW(meter) {
      let infohw = await Meter.infohw(meter);
      let infohw2 = infohw.data.hardware;

      if (infohw2 === undefined) return;
      this.infohw.ADE = infohw2.ADE != undefined ? infohw2.ADE : "N/A";
      this.infohw.CT_max_current =
        infohw2.CT_max_current != undefined ? infohw2.CT_max_current : "N/A";
      this.infohw.modem = infohw2.modem != undefined ? infohw2.modem : "N/A";
      this.infohw.radio_info = infohw2.radio_info != undefined ? true : false;
    },
  },
  mounted() {
    let hour = moment(this.reading.timestamp).format("LTS");
    this.hourConverted = moment(hour, "h:mm:ss A").format("HH:mm:ss");
    this.fn = setInterval(() => {
      this.setTime();
    }, 60 * 1000);
    this.getInfoHW(this.meter.name);
  },
};
</script>

<style scoped>
.disp {
  height: 60px;
  width: 150px;
}
</style>
